export const MATH_START = 'math_'
export const MATH_END = '_math'
export const MATH_REGEX = /(math_.*?_math)/i

export function checkMathLiveExist(str: string) {
  return str.match(MATH_REGEX)
}

export function mathLiveToLatex(matchCode: string) {
  return matchCode.replace(MATH_START, '').replace(MATH_END, '')
}

export function latexToMathLive(latex: string) {
  return `${MATH_START}${latex}${MATH_END}`
}

// app/views/layouts/admin_exam_material.html.erb と app/views/layouts/classroom.html.erb に定義があります
// Mathliveは最初にスタイル効かないので、DummyのDivをMathField作成したら、スタイル再設定されます。
export function resetStyleMathLive() {
  const dummyMathLive = document.getElementById('dummy-mathlive')
  if (dummyMathLive && dummyMathLive.childElementCount == 0) {
    (window as any).MathLive.makeMathField('dummy-mathlive')
  }
}

const mathliveFields: {id: string, mathField: any}[] = []

export const focusMathliveElement = (element: HTMLInputElement) => {
  const mathliveData = element.getAttribute('edbase-mathlive-data')
  if (mathliveData) {
    const found = mathliveFields.find(item => item.id == mathliveData)
    if (found) {
      found.mathField.$focus()
      return
    }
  }
  element.focus()
}

export const createMathliveField = (element: HTMLInputElement, isVirtualKeyboard = true) => {
  if (element.style.display == 'none') {
    return element
  }

  const mathliveFieldHtml = document.createElement('div')
  mathliveFieldHtml.className = 'form-control p-2'

  mathliveFieldHtml.innerHTML = mathLiveToLatex(element.value)
  ;(element.parentElement as any).append(mathliveFieldHtml)
  element.style.display = 'none'

  const mathliveData = `math_${new Date().getTime()}`
  element.setAttribute('edbase-mathlive-data', mathliveData)

  // Style for inline field (show on line)
  if (element.parentElement.parentElement) {
    element.parentElement.parentElement.style.display = 'flex'
    element.parentElement.parentElement.style.alignItems = 'center'
    element.parentElement.style.width = element.style.width
    element.parentElement.style.marginLeft = '8px'
    element.parentElement.style.marginRight = '5px'
  }

  setTimeout(() => {
    const mathField = (window as any).MathLive.makeMathField(mathliveFieldHtml, {
      smartMode: true,
      virtualKeyboardMode: isVirtualKeyboard ? 'onfocus' : 'off',
      virtualKeyboardToolbar: 'none',
      useSharedVirtualKeyboard: true,
      onVirtualKeyboardToggle: (mf) => {
        setTimeout(() => {
          if (document.getElementsByClassName('question-container').length > 0) {
            if (Array.from(document.getElementsByClassName("ML__keyboard")).every( e => e.className.includes("is-visible") == false)) {
              document.getElementsByClassName('question-container')[0].classList.remove('addPaddingBottom')
            } else {
              document.getElementsByClassName('question-container')[0].classList.add('addPaddingBottom')
              let currentPageHeigth = document.body.offsetHeight
              let currentElementPos = mathliveFieldHtml.offsetTop
              let currentScrollPos = document.getElementsByClassName('question-container')[0].scrollTop
              if (((currentPageHeigth - 270)/currentElementPos) < 1.5) {
                document.getElementsByClassName('question-container')[0].scrollTop = currentScrollPos + 200
              }
            }
          }
        },100)
      },
      onContentDidChange: (mf) => {
        const latex = mf.$text()
        element.value = latexToMathLive(latex)
      }
    })

    mathliveFields.push({
      id: mathliveData,
      mathField
    })
  })

  return mathliveFieldHtml
}

export const hideAllMathKeyboard = () => {
  // Close virtualKeyboard
  const frameZones = Array.from(document.querySelectorAll('.ML__keyboard'))
  frameZones.forEach((el) => el.remove())
}

export function detectMath(line: string): { mathCode: string; index: number }[] {
  const result = []
  let matchMath = line.match(MATH_REGEX)
  while (matchMath) {
    result.push({
      mathCode: matchMath[0],
      index: matchMath.index
    })

    line = line.replace(matchMath[0], randomTextByLength(matchMath[0].length))
    matchMath = line.match(MATH_REGEX)
  }

  return result
}

function randomTextByLength(length: number) {
  var result = ''
  var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
  var charactersLength = characters.length
  for (var i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength))
  }
  return result
}
